import type {KeyboardEvent, PropsWithChildren, ReactNode} from "react";
import cn from "classnames";

import {ChevronDownIcon} from "@pg-design/icons-module";
import {capitalize} from "@pg-mono/nodash";

import {useAccordionContext} from "../hooks/use_accordion_context";
import type {AccordionTheme} from "../types/AccordionTheme";

import * as styles from "./Header.module.css";

export interface IProps {
    icon?: ReactNode;
    className?: string;
    dataTestId?: string;
    /**
     * Wystawia nagłówek jako przycisk dostępny z klawiatury (role="button", Enter i Spacja) ze stanem aria-expanded.
     * Domyślnie wyłączone, bo nagłówek bywa opakowaniem na nagłówki h2/h3 lub elementy interaktywne.
     */
    asButton?: boolean;
}

type ClassName = keyof typeof styles;

const getHeaderTheme = (theme: AccordionTheme) => `header${capitalize(theme)}` as ClassName;

export const Header = (props: PropsWithChildren<IProps>) => {
    const context = useAccordionContext(Header.name);

    const onKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
        // Reagujemy tylko na klawisze naciśnięte na samym nagłówku, a nie na elementach w środku (np. checkbox).
        if (event.target !== event.currentTarget || event.repeat) {
            return;
        }
        if (event.key === "Enter" || event.key === " ") {
            // Spacja nie może przewijać strony.
            event.preventDefault();
            context.onExpand();
        }
    };

    const buttonProps = props.asButton ? {role: "button", tabIndex: 0, "aria-expanded": context.expanded, onKeyDown} : {};

    return (
        <div
            className={cn(styles.header, styles[getHeaderTheme(context.theme)], context.expanded && styles.headerExpanded, props.className)}
            onClick={context.onExpand}
            data-testid={props.dataTestId}
            {...buttonProps}
        >
            <div className={styles.headline}>
                {props.icon ? <span className={styles.headlineIcon}>{props.icon}</span> : null} {props.children}
            </div>

            <span className={cn(styles.toggle, context.expanded && styles.rotated)}>
                <ChevronDownIcon size="2" />
            </span>
        </div>
    );
};
import type {KeyboardEvent, PropsWithChildren, ReactNode} from "react";
import cn from "classnames";

import {ChevronDownIcon} from "@pg-design/icons-module";
import {capitalize} from "@pg-mono/nodash";

import {useAccordionContext} from "../hooks/use_accordion_context";
import type {AccordionTheme} from "../types/AccordionTheme";

import * as styles from "./Header.module.css";

export interface IProps {
    icon?: ReactNode;
    className?: string;
    dataTestId?: string;
    /**
     * Wystawia nagłówek jako przycisk dostępny z klawiatury (role="button", Enter i Spacja) ze stanem aria-expanded.
     * Domyślnie wyłączone, bo nagłówek bywa opakowaniem na nagłówki h2/h3 lub elementy interaktywne.
     */
    asButton?: boolean;
}

type ClassName = keyof typeof styles;

const getHeaderTheme = (theme: AccordionTheme) => `header${capitalize(theme)}` as ClassName;

export const Header = (props: PropsWithChildren<IProps>) => {
    const context = useAccordionContext(Header.name);

    const onKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
        // Reagujemy tylko na klawisze naciśnięte na samym nagłówku, a nie na elementach w środku (np. checkbox).
        if (event.target !== event.currentTarget || event.repeat) {
            return;
        }
        if (event.key === "Enter" || event.key === " ") {
            // Spacja nie może przewijać strony.
            event.preventDefault();
            context.onExpand();
        }
    };

    const buttonProps = props.asButton ? {role: "button", tabIndex: 0, "aria-expanded": context.expanded, onKeyDown} : {};

    return (
        <div
            className={cn(styles.header, styles[getHeaderTheme(context.theme)], context.expanded && styles.headerExpanded, props.className)}
            onClick={context.onExpand}
            data-testid={props.dataTestId}
            {...buttonProps}
        >
            <div className={styles.headline}>
                {props.icon ? <span className={styles.headlineIcon}>{props.icon}</span> : null} {props.children}
            </div>

            <span className={cn(styles.toggle, context.expanded && styles.rotated)}>
                <ChevronDownIcon size="2" />
            </span>
        </div>
    );
};
